export default __webpack_public_path__ + "shopping-cart-black-shape.png";